import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const GlobalNoticeContext = createContext(null);

export const GlobalNoticeProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [variant, setVariant] = useState('info'); // info | success | warning | error

  // Hỗ trợ cả open({ title, message, variant }) và open('message', 'variant')
  const open = useCallback((optsOrMessage = {}, variantArg) => {
    const opts = typeof optsOrMessage === 'string'
      ? { message: optsOrMessage, variant: variantArg, title: variantArg === 'error' ? 'Lỗi' : variantArg === 'success' ? 'Thành công' : undefined }
      : optsOrMessage;
    setTitle(opts.title || 'Thông báo');
    setMessage(opts.message || '');
    setVariant(opts.variant || 'info');
    setIsOpen(true);
  }, []);

  const close = useCallback(() => setIsOpen(false), []);

  const ctx = useMemo(() => ({ open, close }), [open, close]);

  const color = variant === 'success' ? 'bg-emerald-600' : variant === 'warning' ? 'bg-amber-600' : variant === 'error' ? 'bg-red-600' : 'bg-gray-900';

  return (
    <GlobalNoticeContext.Provider value={ctx}>
      {children}
      {isOpen && (
        <div className="fixed inset-0 z-[70] flex items-center justify-center">
          <div className="absolute inset-0 bg-black/50" onClick={close} />
          <div className="relative z-10 w-full max-w-md mx-4 rounded-2xl shadow-lg bg-white overflow-hidden">
            <div className={`flex items-center justify-between px-4 py-3 text-white ${color} rounded-t-lg`}>
              <h3 className="text-sm font-medium">{title}</h3>
              <button onClick={close} className="rounded px-2 py-1 hover:bg-white/20" aria-label="Đóng">✕</button>
            </div>
            <div className="p-4 text-sm text-gray-800 whitespace-pre-wrap">{message}</div>
            <div className="p-4 flex justify-end gap-2">
              <button onClick={close} className="h-10 rounded-xl border px-4 text-sm text-gray-700 hover:bg-gray-50">Đóng</button>
            </div>
          </div>
        </div>
      )}
    </GlobalNoticeContext.Provider>
  );
};

export const useGlobalNotice = () => {
  const ctx = useContext(GlobalNoticeContext);
  if (!ctx) throw new Error('useGlobalNotice must be used within GlobalNoticeProvider');
  return ctx;
};


